import { isIOSPWA } from './isIOSPWA';

const DOWNLOAD_ENDPOINT = `${process.env.REACT_APP_API_URL}/api/invoice/download_print_form`;

/**
 * Проверяет, запущено ли приложение внутри нативного Telegram WebView
 * (а не PWA из браузера). TelegramWebviewProxy инжектится только нативным клиентом.
 */
function isTelegramWebView() {
    return !!(window.TelegramWebviewProxy || window.Telegram?.WebApp?.initData);
}

/**
 * Проверяет, запущено ли приложение внутри нативного Max WebView
 * (а не PWA из браузера). window.WebApp с initData инжектится только нативным клиентом.
 */
function isMaxWebView() {
    return !!window.WebApp?.initData;
}

/**
 * Скачивание файла через GET-запрос на api/invoice/download_print_form.
 * В нативном Telegram/Max WebView используется соответствующий нативный downloadFile,
 * в остальных случаях (PWA, браузер) — переход по ссылке.
 * @param {string} url — URL файла для скачивания
 * @param {string} [name] — имя файла при сохранении
 * @param {string} [contractNumber] — номер договора
 */
export function downloadFile(url, name, contractNumber) {
    const params = new URLSearchParams({ url });
    if (contractNumber) {
        params.set('contract_number', contractNumber);
    }
    const downloadUrl = `${DOWNLOAD_ENDPOINT}?${params.toString()}`;
    const fileName = name || 'file';

    if (isTelegramWebView() && window.Telegram?.WebApp?.downloadFile) {
        window.Telegram.WebApp.downloadFile({
            url: downloadUrl,
            file_name: fileName,
        });
    } else if (isMaxWebView() && window.WebApp?.downloadFile) {
        window.WebApp.downloadFile(downloadUrl, fileName);
    } else if (isIOSPWA()) {
        fetch(downloadUrl)
            .then((res) => res.blob())
            .then((blob) => {
                const file = new File([blob], fileName, { type: blob.type });
                // Пробуем share напрямую, без canShare
                return navigator.share({ files: [file] });
            })
            .catch((err) => {
                console.error('share failed:', err);
                fetch(downloadUrl)
                    .then(r => r.blob())
                    .then(blob => {
                        const a = document.createElement('a');
                        a.href = URL.createObjectURL(blob);
                        a.download = fileName;
                        a.click();
                    });
            });
    } else {
        window.location.href = downloadUrl;
    }
}
